import DeveloperInfo from "../common/DeveloperInfo";
import {useQuestionStore} from '../../store/useQuestionStore'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useState } from "react";
import { QUESTION_STATE_SCENARIOS } from "../../constants/appConstants";

export function QuestionState({questionIndex}) {
    const questionStore = useQuestionStore()
    const selectedVal = questionStore.questionState[questionIndex]?.answerState || ''

    const handleChange = (event) => {
        questionStore.updateAnswerState(questionIndex.toString(), event.target.value)
    };
    

    return <DeveloperInfo>
         <FormControl variant="standard" fullWidth={true}>
        <InputLabel id="demo-simple-select-standard-label">Select Question State</InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={selectedVal}
          onChange={handleChange}
          label="Select Question State"
        >
            {Object.entries(QUESTION_STATE_SCENARIOS).map(([scenrio]) => {
                return <MenuItem value={scenrio}>{scenrio}</MenuItem>
            })}
        </Select>
      </FormControl>
    </DeveloperInfo>
}